import { useEffect } from 'react';

export const ADM_ID = 'comp_adm_2024_415_assistenti';
export const ADM_TITLE = 'Preparazione Concorso ADM 2026-2027';
export const ADM_SUBTITLE = "Basi di studio per i concorsi dell'Agenzia delle Dogane e dei Monopoli";

// The new presentation is inactive until the reviewed ADM edition is released.
export function isAdmPreparation(contest) {
  return contest?.contest_id === ADM_ID && contest?.title === ADM_TITLE;
}

export function AdmCover({ contest, className = '' }) {
  if (!isAdmPreparation(contest)) return null;
  return <img src="/covers/adm-preparazione-2026-2027.svg?v=20261004-ce" width="1200" height="630"
    alt="ConcorsiEssentials — ADM, Agenzia delle Dogane e dei Monopoli — Preparazione concorsi 2026-2027"
    className={`block h-auto w-full ${className}`} data-testid="adm-preparation-cover" />;
}

export function AdmMetadata({ contest }) {
  const active = isAdmPreparation(contest);
  const description = contest?.short_description;
  useEffect(() => {
    if (!active) return undefined;
    const previousTitle = document.title;
    const existing = document.querySelector('meta[name="description"]');
    const meta = existing || document.createElement('meta');
    const previousContent = meta.getAttribute('content');
    if (!existing) { meta.setAttribute('name', 'description'); document.head.appendChild(meta); }
    document.title = `${ADM_TITLE} | ConcorsiEssentials`;
    meta.setAttribute('content', description || ADM_SUBTITLE);
    return () => {
      document.title = previousTitle;
      if (!existing) meta.remove();
      else if (previousContent === null) meta.removeAttribute('content');
      else meta.setAttribute('content', previousContent);
    };
  }, [active, description]);
  return null;
}

export function AdmNotice({ contest, compact = false }) {
  if (!isAdmPreparation(contest)) return null;
  return <p className="mt-3 rounded-xl bg-brand-light p-3 text-sm leading-6 text-brand-dark" data-testid="adm-preparation-notice">
    {compact ? 'Preparazione generale: non garantisce la corrispondenza con un futuro bando.' :
      'Preparazione generale, non un corso certificato su un futuro bando. Verifica requisiti, profili, materie e prove nella documentazione ufficiale del concorso che ti interessa.'}
  </p>;
}
